<!-- <div nz-row nzJustify="space-around">
    @if (newIncidentCount > 0) {
        <div nz-col  class="blockDiv blockDivNew" (click)="onClickNewBreakdowns()">
          <h2>NEW BREAKDOWNS</h2>
          <h1>{{ newIncidentCount }}</h1>
        </div>
    }
    <div nz-col  class="blockDiv blockDivOpen" (click)="onClickAllBreakdowns()">
        <h2>OPEN BREAKDOWNS</h2>
        <h1>{{ openIncidentCount }}</h1>

    </div>
    <div nz-col  class="blockDiv blockDivBlue" (click)="sharedDataService.isWhatsappDrawerVisible = true">
        <h2>MESSAGES</h2>
        <h1>{{ whatsappService.openMessageCount() }}</h1>
    </div>

</div> -->

<div nz-row nzJustify="end" style="margin-top: 20px; margin-bottom: 8px;">
    <div nz-col>
        <button nz-button [nzType]="isMapVisible() ? 'primary' : 'default'" (click)="toggleMap()">
            <span nz-icon [nzType]="isMapVisible() ? 'environment' : 'environment'" nzTheme="outline"></span>
            {{ isMapVisible() ? 'Hide Map' : 'Show Map' }}
        </button>
    </div>
</div>

<div nz-row nzJustify="space-between" nzGutter="16">
    <div nz-col [nzSpan]="isMapVisible() ? 17 : 24">
        <app-open-incident-table 
        [isAbridged]="true"
        [etaChanges]="etaChanges()"
        [selectedIncident]="incidentSelected()"
        ></app-open-incident-table>
    </div>
    @if (isMapVisible()) {
        <div nz-col nzSpan="7">
            <app-map-incidents [incidents]="operatorIncidents()" (incidentSelected)="onIncidentSelected($event)"></app-map-incidents>
        </div>
    }
</div>


